<!--
    课程分享-课程批量授权-授权账号弹窗
    作用：第四步：提交授权数据
    说明：版本3.0
-->
<template>
  <div class="table-demo">
    <el-scrollbar wrap-style="overflow-x:hidden;">
      <div class="table-main">
        <div v-if="authType==='1'">
          <div class="title">授权用户账号</div>
          <el-table
            ref="table1"
            :data="accountAuth"
            fit
            height="400"
            highlight-current-row
            class="table"
          >
            <el-table-column
              v-for="(item,index) in accountTd"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
            />
          </el-table>
        </div>
        <div v-else>
          <div class="title">授权校区名单</div>
          <el-table
            ref="table1"
            :data="numAuth"
            fit
            highlight-current-row
            class="table"
          >
            <el-table-column
              v-for="(item,index) in numTd"
              :key="index"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
            />
          </el-table>
        </div>
        <div
          class="title"
          style="margin-top:20px">授权课程</div>
        <el-table
          ref="table1"
          :data="selCourse"
          fit
          highlight-current-row
          class="table"
        >
          <el-table-column
            v-for="(item,index) in courseTd"
            :key="index"
            :label="item.label"
            :prop="item.prop"
            :width="item.width"
          />
        </el-table>
      </div>
    </el-scrollbar>
    <div class="bottom-btns">
      <el-button @click="lastStep">上一步</el-button>
      <el-button
        type="primary"
        @click="submitData">提交</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FourStep',
  props: {
    authType: String,
    selCourse: Array,
  },
  data() {
    return {
      accountAuth: [],
      accountTd: [{
        prop: 'search_staff_name',
        label: '用户名称',
      }, {
        prop: 'search_staff_mobile',
        label: '用户手机号',
      }, {
        prop: 'search_clients_name',
        label: '校区名称',
      }, {
        prop: 'search_clients_code',
        label: '校区代码',
      }],
      numAuth: [],
      numTd: [
        {
          prop: 'school_name',
          label: '校区名称',
        }, {
          prop: 'school_code',
          label: '校区代码',
        }, {
          prop: 'auth_number',
          label: '课件允许使用次数',
        },
      ],
      courseList: [],
      courseTd: [{
        prop: 'name',
        label: '课程名称',
      }, {
        prop: 'code',
        label: '课程编号',
      }, {
        prop: 'detail_count',
        label: '课时总时',
      },
      {
        prop: 'updated_at',
        label: '更新时间',
      }],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      const arr = [];
      if (this.authType === '1') {
        this.$store.state.accountAuth.forEach((item) => {
          item.staff_id_list.forEach((v) => {
            arr.push(v);
          });
        });
        this.accountAuth = arr;
      } else {
        this.$store.state.accountAuth.forEach((item) => {
          arr.push({
            id: item.id,
            school_name: item.school_name,
            school_code: item.school_code,
            auth_number: item.auth_number,
          });
        });
        this.numAuth = arr;
      }
    },
    lastStep() {
      this.$emit('lastStep');
    },
    submitData() {
      this.$emit('submitData');
    },
  },
};
</script>
<style lang="scss" scoped>
.table-demo{
    height: 100%;
    display: flex;
    flex-direction: column;
    .table-main{
      flex:1
    }
  .title{
    font-size: 14px;
    padding-bottom: 20px;
  }
}
.bottom-btns{
        padding-top: 20px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/volumeAuth/components/fourStep.vue